module.exports = __webpack_public_path__ + "static/media/git.26cffa6c.svg";